module.exports = __webpack_public_path__ + "static/media/attach.fea40574.svg";